import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createGroup = React.createContext({});
export let createGroupMachine: any;

const MODULE_NAME = 'machines.studentsBatch.createGroup';
const log: any = LoggerModule?.getInstance();

export const useSMCreateGroup = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createGroupMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createGroupMachine);

  return {
    createGroupMachine,
    createGroupState: state,
    createGroupSend: send,
  };
};
